import { loadCittaComuniOptions } from '@utils/checkout'
import { useEffect, useState } from 'react'

export function useCittaOptions() {
  const [cittaOpts, setCittaOpts] = useState([])

  useEffect(() => {
    const fetchOptions = async () => {
      const options = await loadCittaComuniOptions()
      setCittaOpts(options)
    }

    fetchOptions()
  }, [])

  return cittaOpts
}
